



























import Vue from "vue";

export default Vue.extend({
  name: "TimeCard",
  components: {},
  props: {
    check: {
      required: false,
      type: Boolean,
    },
    timeMili: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {};
  },
  methods: {
    getWeekDay(): string {
      /** Get the day of the week from a timestamp in milliseconds, based on the selected locale. */
      const locale = this.$i18n.locale || navigator.language;
      return new Date(this.timeMili)
        .toLocaleDateString(locale, { weekday: "long" })
        .toString();
    },

    getShortWeekDay(): string {
      /** Get the short day of the week from a timestamp in milliseconds, based on the selected locale. */
      const locale = this.$i18n.locale || navigator.language;
      return new Date(this.timeMili)
        .toLocaleDateString(locale, { weekday: "short" })
        .toString();
    },
    getDay(): string {
      /** Get the day of the month from a timestamp in milliseconds, based on the selected locale. */
      const locale = this.$i18n.locale || navigator.language;
      return new Date(this.timeMili)
        .toLocaleDateString(locale, { day: "2-digit" })
        .toString();
    },
    getShortDate(): string {
      /** Get the short date from a timestamp in milliseconds, based on the selected locale. */
      const locale = this.$i18n.locale || navigator.language;
      return new Date(this.timeMili)
        .toLocaleDateString(locale, {
          year: "2-digit",
          month: "2-digit",
          day: "2-digit",
        })
        .toString();
    },
    getLongDate(): string {
      /** Get the long date from a timestamp in milliseconds, based on the selected locale. */
      const locale = this.$i18n.locale || navigator.language;
      return new Date(this.timeMili)
        .toLocaleDateString(locale, {
          year: "numeric",
          month: "long",
        })
        .toString();
    },
  },
});
